import {useAgendaEntityResource} from '@/features/agenda/hooks/useAgendaEntityResource'
import {useTranslation} from '@/translations/i18n'
import {StyledAgendaToolbarTitle} from './style'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AgendaEntity} from '@/features/agenda/types'
import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {usePermissions} from '@/features/auth/store/store'

export const AgendaToolbarSubjectTitle = ({id, entity}: {id: string; entity: AgendaEntity}) => {
    const {t} = useTranslation()
    const {data, isLoading, isError} = useAgendaEntityResource({
        entity,
        id,
        responseType: 'small'
    })

    const permissions = usePermissions()

    if (isLoading) {
        return (
            <StyledAgendaToolbarTitle align="center" justify="center">
                <Skeleton height={24} width={200} />
            </StyledAgendaToolbarTitle>
        )
    }

    if (isError) {
        return (
            <StyledAgendaToolbarTitle align="center" justify="center">
                <InputHelpText error={t('errors:default')} />
            </StyledAgendaToolbarTitle>
        )
    }

    if (!data) {
        return (
            <StyledAgendaToolbarTitle align="center" justify="center">
                {t('commons:no_results')}
            </StyledAgendaToolbarTitle>
        )
    }

    return (
        <Flexbox align="center" justify="center">
            <StyledAgendaToolbarTitle direction="column" align="center" justify="center">
                <h3>
                    {entity == 'users' ? (
                        data.fullName
                    ) : permissions?.medicalRecords?.read ? (
                        <ButtonLink shape="text" variant="tertiary" to={`/patients/${id}/medical-record`}>
                            {data.fullName}
                        </ButtonLink>
                    ) : (
                        data.fullName
                    )}
                </h3>
                {entity == 'users' && 'specializationName' in data && <p>{data.specializationName}</p>}
            </StyledAgendaToolbarTitle>
        </Flexbox>
    )
}
